import Axios from 'axios'
import Vue from 'vue'
const host = window.location.protocol + "//" + window.location.host;
const baseIp = process.env.NODE_ENV == 'development' ? '/tent' : host;
const service = Axios.create({
    baseURL: baseIp,
    timeout: 10 * 60 * 1000,
    withCredentials: true // 跨域请求时发送cookie
})
Axios.defaults.headers.post['Content-Type'] = 'application/json';

service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).token;
        if (token) {
            config.headers['token'] = `${token}`;
        }
        return config
    },
    error => {
        return Promise.reject(error.response)
    }
)
service.interceptors.response.use(
    response => {
        // 如果是文件流（Blob），直接返回原始响应
        const contentType = response.headers['content-type'];
        // 判断是否为文件流（常见文件类型）
        const isFileResponse =
            contentType?.includes('application/octet-stream') ||
            contentType?.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || // .xlsx
            contentType?.includes('application/vnd.ms-excel') || // .xls
            contentType?.includes('application/pdf') ||         // .pdf
            contentType?.includes('text/csv') ||                 // .csv
            contentType?.includes('application/zip')  //.zip

        if (isFileResponse) {
            // 是文件流，直接返回原始响应（包含 blob data 和 headers）
            return response;
        }
        if (response.status === 200 || response.status == 201) {
            if (response.data.code == 407) {
                Vue.prototype.$errorMsg(response.data.message)
                localStorage.removeItem('userInfo')
                window.location.replace("/#/login");
            }
            if (response.data.success == false) {
                Vue.prototype.$errorMsg(response.data.message)
                return response.data
            }
            return response.data
        } else {
            Vue.prototype.$errorMsg(response.message || "业务异常");
            throw new Error(response.status)
        }
    },
    error => {
        Vue.prototype.$errorMsg(error);
        return Promise.reject({ code: 500, msg: error })
    }
)

export default (url, method, submitData, options = {}) => {
    return service({
        url,
        method,
        [method.toLowerCase() === 'post' ? 'data' : 'params']: submitData,
        ...options
    });
};
